module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-container__item"
  }, [_c('ext-link', {
    staticClass: "header-container__logo",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    staticClass: "header-container__img",
    attrs: {
      "src": _vm.logoImage,
      "alt": _vm.portalName
    }
  })]), (!!_vm.portalName) ? _c('h2', {
    staticClass: "header-container__name",
    class: _vm.logoTextSize
  }, [_vm._v(_vm._s(_vm.portalName))]) : _vm._e(), (_vm.$slots.link) ? _c('div', {
    staticClass: "header-container__link",
    class: [{
      container__link_margin: !_vm.portalName
    }, {
      container__link_small: !!_vm.portalName
    }]
  }, [_vm._t("link")], 2) : _vm._e()], 1), (_vm.$slots.personal) ? _c('div', {
    staticClass: "header-container__item"
  }, [_c('div', {
    staticClass: "header-container__personal d-felx align-items-center"
  }, [(_vm.isAuthorized && _vm.hasApiModuleConsultations) ? _vm._t("addConsultations") : _vm._e(), _vm._t("accessibilityMode"), _vm._t("personal")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4aea64","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header/Top.vue
// module id = 5f414eb7dfbbf8c6aaca
// module chunks = 7